<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="importAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!isFile" :vm-active="isModalImportScopeVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        h3 {{$t('strings.step0')}}
        br
        img.imagen(src="@/assets/excel.png")
        br
        br
        p 1- {{$t('strings.step1')}}
        span 2- {{$t('strings.step2')}}
        a.link(@click="atModalIdCategory()") show source of category ID
        p 3- {{$t('strings.step3')}}
        p 4- {{$t('strings.step4')}}
        p 5- {{$t('strings.step5')}}
        span 6- {{$t('strings.step6')}}
        a.link(@click="atModalIdProject()") show source of project ID
        br
        br
        b-form-group
          input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx")
        span
          slot {{$t('strings.download_a')}}
          a(@click="downloadTemplate") &nbsp;{{$t('strings.sample_csv')}}
          slot &nbsp;{{$t('strings.example_file')}}
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalImportScope',
  props: {
    title: {
      type: String,
      default: 'Import CSV or Excel file'
    },
    project_id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      file: ''
    }
  },
  computed: {
    ...mapGetters([
      'isModalImportScopeVisible',
      'isModalImageVisible'
    ]),
    isFile () {
      return !this.file
    }
  },
  methods: {
    ...mapActions([
      'importScopeData',
      'downloadTemplate',
      'setModalImportScopeVisible',
      'setModalImageVisible'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    importAction () {
      this.importScopeData({ file: this.file, project_id: this.project_id })
    },
    close () {
      this.setModalImportScopeVisible(false)
    },
    atModalIdProject () {
      this.setModalImageVisible({ 'isImage': true, 'imageIdProject': true, 'imageIdCategory': false })
    },
    atModalIdCategory () {
      this.setModalImageVisible({ 'isImage': true, 'imageIdProject': false, 'imageIdCategory': true })
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.imagen {
    width: 80%;
    height: 80%;
    background: #e4e4e4;
    box-sizing: content-box;
}
a {
  cursor: pointer;
}
.spacer {
    margin-bottom: 10px;
  }
</style>
